import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import parameters from './__generated__/mainPopupContentFilterByAriQuery.graphql';

type EntryPointParams = {
	filterId: string;
	activationId: string;
	cloudId: string;
	isAnonymous: boolean;
};

export const popupContentEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-issue-navigator-actions-custom-filters-details-entrypoint" */ './main.tsx'
			),
	),
	getPreloadProps: ({ filterId, activationId, cloudId, isAnonymous }: EntryPointParams) => {
		const filterAri = createAri({
			resourceOwner: 'jira',
			cloudId,
			resourceType: 'filter',
			resourceId: filterId,
			activationId,
		});

		return {
			queries: {
				filterData: {
					parameters,
					variables: {
						filterAri,
						isAnonymous,
					},
				},
			},
			extraProps: {
				filterId,
				filterAri,
			},
		};
	},
});
